import { render, staticRenderFns } from "./search-detail.vue?vue&type=template&id=517522b0&scoped=true&"
import script from "./search-detail.vue?vue&type=script&lang=js&"
export * from "./search-detail.vue?vue&type=script&lang=js&"
import style0 from "./search-detail.vue?vue&type=style&index=0&id=517522b0&lang=scss&scoped=true&"
import style1 from "./search-detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517522b0",
  null
  
)

export default component.exports